import React from 'react';
import loadingSpinner from './loadingSpinner.svg';

const LoadingSpinner = () => (
    <img src={loadingSpinner} alt="BigCo Inc. logo"/>
);

export default LoadingSpinner;
